import { render, staticRenderFns } from "./ModuleImage.vue?vue&type=template&id=d8c98132&"
import script from "./ModuleImage.vue?vue&type=script&lang=js&"
export * from "./ModuleImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports